import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getCostBudget } from '@/service/operate/budgetReport';
export default function useCostBudget(params) {
  var costBudget = ref({
    totalYsje: 0,
    totalYssyje: 0,
    costBudgetListByDept: []
  });
  // 查询时间范围内停机详情
  var getCostBudgetAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getCostBudget(params.value);
          case 2:
            data = _context.sent;
            if (data) {
              costBudget.value = data;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getCostBudgetAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var costBudgetTotal = computed(function () {
    return [{
      num: costBudget.value.totalYsje,
      desc: '总预算金额/元'
    }, {
      num: costBudget.value.totalYssyje,
      desc: '总预算剩余/元'
    }];
  });
  var costBudgetData = computed(function () {
    var lineData1 = costBudget.value.costBudgetListByDept.map(function (item) {
      return item.ysje;
    });
    var lineData2 = costBudget.value.costBudgetListByDept.map(function (item) {
      return item.yssyje;
    });
    var xLabels = costBudget.value.costBudgetListByDept.map(function (item) {
      return item.departmentName;
    });
    var legendData = ['预算金额', '剩余预算'];
    return {
      xLabels: xLabels,
      lineData: [lineData1, lineData2],
      legendData: legendData,
      colors: ['#82A3FF', '#5AC57F'],
      grid: {
        left: 70,
        top: 40,
        bottom: 30,
        right: 20
      },
      customTooltip: true,
      tooptipFormatter: function tooptipFormatter(params1) {
        var res = "\n                <div >\n                  <div class=\"flex align-center\">\n                    <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                  </div>\n                ");
        params1.forEach(function (item) {
          res += "\n                  <div >\n                    ".concat(item.marker, "\n                    <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                    <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value, "\u5143</span>\n                  </div>\n                ");
        });
        res += '</div>';
        return res;
      }
    };
  });
  return [costBudgetTotal, costBudgetData, getCostBudgetAsync];
}